module.exports = __webpack_public_path__ + "img/mobile-menu-panel-bg.0e552282.jpg";